<template>
	<div class="match">
		<div class="wrapper">
			<div class="match_heading">{{ $t('sports.box.categories.' + category) }}</div>
			
			<div class="match_row">
				<categories :data="categories"></categories>
				
				<div class="match_right">
					<div class="tab">
						<match-header></match-header>
						
						<tab :headings="{active : 'Последние', schedule: 'Расписание'}" active-key="active" :base="true">
							<template v-slot:active>
								<list v-if="matches" :data="matches"></list>
								<div v-else-if="matchesLoading" class="info-text"></div>
								<div v-else class="info">Нет данных</div>
							</template>
							<template v-slot:schedule>
								<list v-if="matchesSchedule" :data="matchesSchedule"></list>
								<div v-else-if="matchesScheduleLoading" class="info-text"></div>
								<div v-else class="info">Нет данных</div>
							</template>
						</tab>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import MatchHeader from '../../Common/MatchHeader';
	import Categories from "../Components/Categories";
	import Tab from "../../../Tab/Tab";
	import List from "../Components/List";

	export default {
		components: {
			MatchHeader,
			Categories,
			Tab,
			List
		},

		data() {
			return {
				categories: null,
				matches: null,
				matchesSchedule: null,
				matchesLoading: true,
				matchesScheduleLoading: true,
				category: this.$route.params.id
			}
		},

		created() {
			this.axios.get('/goalserve/box/weights/' + this.category)
				.then(({data}) => {
					this.matches = data.res;
					this.matchesLoading = false;
				})
				.catch(() => {
					this.matchesLoading = false;
				});
			this.axios.get('/goalserve/box/weights/' + this.category + '/schedule')
				.then(({data}) => {
					this.matchesSchedule = data.res;
					this.matchesScheduleLoading = false;
				})
				.catch(() => {
					this.matchesScheduleLoading = false;
				});
			this.axios.get('/goalserve/box/weights')
				.then(({data}) => {
					this.categories = data.res;
				});
		},

		methods: {

		}
	}
</script>

<style scoped>

</style>